import React, {useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import {Typography} from '@material-ui/core';
import {Link} from 'react-router-dom';
import {UserContext} from 'context/UserContext';
import {PartyHatIcon} from './icons/icons';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '0.1rem',
        paddingTop: '0.5rem',
    },
    link: {
        color: 'unset',
    },
    icon: {
        fontSize: '3.4375em',
        width: '1.15em',
    }
}));

const Greeting = () => {
    const classes = useStyles();
    const {user} = useContext(UserContext);

    return (
        <div className={classes.root}>
            <Link to='/settings' className={classes.link}>
                {['testing.mmseas.dev@gmail.com'].includes(user?.email) ? (
                    <PartyHatIcon className={classes.icon} />
                ) : (
                    <AccountCircleIcon className={classes.icon} />
                )}
            </Link>
            <Typography variant='h5' component='h2'>
                Welcome Back
                <br />
                <b>{user?.firstname}</b>
            </Typography>
        </div>
    );
};

export default Greeting;
